// src/admin/components/CampFinancialBadge.jsx
//
// Subtle status badge for a camp (SCHEDULED / READY / IN_PROGRESS /
// COMPLETED / OVERDUE). Deliberately avoids large colored blocks.

import React from 'react';
import { getCampStatusClass, formatStatusLabel } from './adminHelpers';

export default function CampFinancialBadge({ status, size = 'md' }) {
  const sizeClass = size === 'sm' ? 'text-[10px] px-2 py-0.5' : 'text-xs px-2.5 py-1';

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-semibold ${sizeClass} ${getCampStatusClass(
        status
      )}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {formatStatusLabel(status)}
    </span>
  );
}
